export default class seoEntity{
    "seo_id": 1;
    "code": null;
    "meta_keywords": "";
    "meta_description": "";
    "title": "";
    "og_title": "";
    "og_description": "";
    "og_image_url": "";
    "created_at": null;
    "updated_at": null;
    "file"!:File;
}